"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StageVariantBasicType = void 0;
exports.WorkflowTag = WorkflowTag;
var _lodash = require("lodash");
var React = _interopRequireWildcard(require("react"));
var _colors = require("../../common/colors");
var _iconNames = require("../icon/iconNames");
var _Tag = require("./Tag");
var _excluded = ["children", "icon", "intent", "text", "variant"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StageVariantBasicType = {
  APPLIED: 'applied',
  HIRED: 'hired',
  INTERVIEW: 'interview',
  OFFER: 'offer',
  REJECTED: 'rejected',
  REVIEW: 'review'
};

/**
 * NOTE: (Luce) Content of Tag will default to the name of the variant supplied
 */
exports.StageVariantBasicType = StageVariantBasicType;
function WorkflowTag(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    intent = _ref.intent,
    text = _ref.text,
    variant = _ref.variant,
    tagProps = _objectWithoutProperties(_ref, _excluded);
  var colorFamilies = {
    applied: _colors.ColorFamily.IVORY,
    hired: _colors.ColorFamily.GREEN,
    interview: _colors.ColorFamily.MARINE,
    offer: _colors.ColorFamily.GREEN,
    rejected: _colors.ColorFamily.RED,
    review: _colors.ColorFamily.YELLOW
  };
  var icons = {
    applied: _iconNames.IconNames16.APPLIED,
    hired: _iconNames.IconNames16.CHECK_CIRCLE,
    interview: _iconNames.IconNames16.COMMENT_SQUARE,
    offer: _iconNames.IconNames16.ENVELOPE_CLOSED,
    rejected: _iconNames.IconNames16.REJECTED,
    review: _iconNames.IconNames16.REVIEW
  };
  var workflowTagProps = {
    icon: variant ? icons[variant] : icon,
    minimal: true,
    muted: true,
    round: true,
    large: true
  };
  if (variant) {
    workflowTagProps.colorFamily = colorFamilies[variant];
  } else if (intent) {
    workflowTagProps.intent = intent;
  }
  return /*#__PURE__*/React.createElement(_Tag.Tag, _extends({}, tagProps, workflowTagProps), text || children || (0, _lodash.capitalize)(variant));
}